// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"998":"922e8fd6583382575840","1700":"811e8a8608e7ebeb6060"}[chunkId] + ".js";
};